import Vue from 'vue'

var config = {}
if (process.env.NODE_ENV === 'development') {
    config = {
        SITE: "http://localhost:8080",
        API: "http://cnarefe-api-local:8000/api",
        API_NOMINATIM: "https://nominatim.openstreetmap.org",
        FILE_TYPE_ACCEPT: ["application/pdf", "image/jpeg", "image/png"],
        MAX_FILE_SIZE: 1048576,
        VERSION : "2.4.0 dev"
    }
} else if (process.env.NODE_ENV === 'production') {
    config = {
        SITE: "https://dev.cpam77.fr",
        API: "https://dev.cpam77.fr/api/api",
        API_NOMINATIM: "https://nominatim.openstreetmap.org",
        FILE_TYPE_ACCEPT: ["application/pdf", "image/jpeg", "image/png"],
        MAX_FILE_SIZE: 6291456,
        VERSION : "2.4.0"
    }   
    // config = {
    //     SITE: "https://www.ameli-rfe.fr",
    //     API: "https://www.ameli-rfe.fr/api/api",
    //     API_NOMINATIM: "https://nominatim.openstreetmap.org",
    //     FILE_TYPE_ACCEPT: ["application/pdf", "image/jpeg", "image/png"],
    //     MAX_FILE_SIZE: 6291456,
    //     VERSION : "2.4.0"
    // }
}

Vue.prototype.$config = config;



// WEBPACK FOOTER //
// ./src/public/config.js